import { render, staticRenderFns } from "./AgencesByEntity.vue?vue&type=template&id=4ad22bc8&"
import script from "./AgencesByEntity.vue?vue&type=script&lang=js&"
export * from "./AgencesByEntity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports